<template>
  <div class="panel-components-hidden-elements" v-show="this.show">

    <div class="he-heading">
      <h5>{{ $t(`ct-background-page`)}}</h5>
    </div>

    <div class="he-heading" style="overflow-y: scroll; max-height: 500px; padding-top: 0">
      <box-color-component ref="backgroundColorPage"></box-color-component>
      <image-component ref="srcPage" style="padding-top: 30px"></image-component>
    </div>


  </div>
</template>
<script>

  import BoxColorComponent from "../../resources/BoxColor";

  export default {
    name: 'BackgroundPageEdition',
    components: {
      BoxColorComponent,
      'image-component': () => import('../../resources/Image'),
    },
    data() {
      return {
        show: false,
      }
    },
    methods: {
      showPanel() {
        this.show = !this.show;
        return this.show;
      },
        hidePanel() {
        let vm = this;
        vm.show = false;
      }
    },
    mounted() {
      let vm = this;

      this.$root.$on('showBgConfigPage', (element) => {
        vm.show = !vm.show;

        this.$refs['backgroundColorPage'].setValues(element.resources['backgroundColor'], element);
        this.$refs['srcPage'].setValues(element.resources['src'], element);
      });

    }
  }
</script>
<style lang="scss" scoped>


  .panel-components-hidden-elements {
    width: 280px;

    .form-group{
      padding-bottom: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/base/sidebar/BackgroundPageEdition.vue